export var FileType;
(function (FileType) {
    FileType["AUDIO"] = "AUDIO";
    FileType["VIDEO"] = "VIDEO";
    FileType["IMAGE"] = "IMAGE";
    FileType["EBOOK"] = "EBOOK";
    FileType["OTHER"] = "OTHER";
})(FileType || (FileType = {}));
//# sourceMappingURL=FileType.js.map